<script>
import baseview from '@/components/base/baseview'
import {fn_Login } from '@/framework/login/login'
import {getFnDecrypt } from '@/api/common/login'
import Cookies from 'js-cookie'
import LoginFail from '@/layout/login/LoginFail'
import router from '@/router'
import store from '@/store'

export default {
  name: 'misLogin',
  mixins: [baseview],
  components: {
    LoginFail,
  },
  data() {
    return {
      showPassword:false,
      showFail: false,
      userData: {
        userId: '',
        userPw: '' ,
        sysId: '',
        // system: 'SMART',
      },
      isSaveID: false,
      image: require(`@/assets/images/bg/bg_login.jpg`),
      snackbar: false,
      msg: '',
      timeout: 2000,       
    }
  },
  mounted() {     
      //this.userData.userId =  this.$route.query.moceanID;      
      //this.signIn()  
  },   
  created() { 
      // console.log('user Id : ', this.$route.query.user_id )  
      this.loadData()

  },
  methods: {
    async loadData() {
      this.isLoading = true; // Bắt đầu loading
      try {
        await this.getFnDecrypt();
        await this.signIn();
      } catch (error) {
        console.error("Lỗi khi tải dữ liệu:", error);
      } finally {
        this.isLoading = false; // Kết thúc loading
      }
    },
    async getFnDecrypt(){
      let param = {
        userId : this.$route.query.user_id
      }
      const res = await getFnDecrypt(param)
      // console.log(res)
      // console.log('res.usrId : ', res.USR_ID ) 
      this.userData.userId = res.USR_ID
      this.userData.userPw = 'MISLOGIN'; 
      this.userData.sysId = '20'
    },
    // log in
    async signIn() { 
        try { 
            const res = await fn_Login(this.userData)
            if (res.result) {
              // console.log('res.result : ', res.result )  
              // 🔄 Gọi API lấy menu & thêm dynamic route
              await store.dispatch('menu/GetGridMenu', {
                userId: this.userData.userId,
              })
              // 🔁 Chuyển đến v20Menu
              //  router.push('/mainLayout')          
              this.$router.replace('v20Menu') ;  // 👉 Điều hướng ngay tại đây           
            } else {
              if(res.msg !== 'loginFail') {
                this.snackbar = true
                this.msg = res.msg
              } else {
                this.showFail = true
              }
            }
          } catch (err) {
          console.error('Login error:', err)
          this.showFail = true
        }      

    },   
  },
}
</script>